<template>
    <div class="benefit-preview" :class="{ 'benefit-preview--logo' : benefit.logo }">
        <div class="benefit-preview__image">
            <lazy-image :src="imageUrl" :src-small="smallPath" :blur="1"></lazy-image>
        </div>
        <h2 class="benefit-preview__heading heading heading--3">{{ benefit.title }}</h2>
        <div class="benefit-preview__text">{{ benefit.description }}</div>
        <div class="benefit-preview__logo" v-if="benefit.logo" :class="{ 'benefit-preview__logo--big': bigLogo }" :style="{ backgroundImage: 'url(' + benefit.logo + ')' }"></div>
    </div>
</template>
<script>
    import LazyImage from "./LazyImage";
    export default {
        components: {LazyImage},
        props: ["benefit", "bigLogo"],
        computed: {
            imageUrl() {
                return process.env.BASE_URL + this.benefit.image;
            },
            smallPath() {
                let smallPath = this.benefit.image.replace('.jpg', '_small.jpg');
                smallPath = smallPath.replace('.png', '_small.png');

                return process.env.BASE_URL + smallPath;
            }
        }
    }
</script>

<style lang="scss">
    .benefit-preview {
        &--logo {
            @media (max-width: 1439px) {
                padding-bottom: 75px;
            }
        }

        &__image {
            .lazy-image__placeholder {
                width: 100%;
                padding-bottom: 66%;
                background-size: contain;
                margin-bottom: 30px;
                background-color: none;
                overflow: hidden;
            }
        }

                &__image {
            .lazy-image__container {
                background-size: contain;
            }
        }

        &__heading {
            &.heading {
                margin-bottom: 15px;
            }
        }

        &__text {
            font-weight: 400;
            font-family: LegacyPro,Times New Roman,Times,serif;
            font-size: 16px;
            line-height: 1.57;
            color: rgba(96,75,51,.7);
            margin: 0;
        }

        &__logo {
            width: 75px;
            height: 75px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center bottom;
            position: absolute;
            bottom: 20px;
            right: 20px;
            margin-top: 20px;

          &--big {
            width: 125px;
            height: 125px;
            position: relative;
            float: right;
            right: 0;
            margin-top: 0;
          }
        }
    }
</style>


